import { trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss'],
  animations: []
})
export class LoadingModalComponent {
  @Input() visible = false;
  @Input() status: 'loading' | 'success' | 'error' = 'loading';
  @Input() message = '';
  @Output() closed = new EventEmitter<void>();

  close() {
    this.visible = false;
    this.closed.emit();
  }

}
